import React from 'react';
import HeaderDropdown from '../../Components/Header/HeaderDropdown/HeaderDropdown';
import Divider from '@mui/material/Divider';
import {
	useAvailableProductListItems,
	useAvailableAdminListItems,
} from './productPicker.utils';
import { ProductPickerItemProps, ProductPickerItem } from './ProductPickerItem';

const ProductPicker = ({ children }: { children: React.ReactNode }) => {
	const products = useAvailableProductListItems();
	const adminSections = useAvailableAdminListItems();

	const mapMenuItemsToElements = React.useCallback(
		(item: ProductPickerItemProps) => (
			<ProductPickerItem key={`product-picker-${item.text}`} {...item} />
		),
		[],
	);

	const Products = products.map(mapMenuItemsToElements);
	const Admins = adminSections.map(mapMenuItemsToElements);

	const Menu = () => {
		// Add divider if you have both
		if (
			products &&
			products.length > 0 &&
			adminSections &&
			adminSections.length > 0
		) {
			return [
				...Products,
				<Divider key="divider" component="li" />,
				...Admins,
			];
		}
		// Otherwise return whichever has contents
		else return [...Products, ...Admins];
	};

	return (
		<HeaderDropdown
			// text="test"
			cy="product-picker"
			anchorOrigin="right"
			list={Menu()}>
			{children}
		</HeaderDropdown>
	);
};

export default ProductPicker;
